/**
 * Whether the composer offers dictation, read off `GET /ai/status` (R57): no microphone at all
 * while the server does not offer it (switched off, or the trainer outside the group), and a
 * microphone that refuses, for the same reason as sending, while Buddy cannot work.
 */

import type { TrainWithMeModulesAiDtosResponsesAiStatusResponse as StatusDto } from '~/shared/api/generated/model';

export type AiDictationOffer =
  | { readonly kind: 'none' }
  /** The longest clip, in seconds; the recording stops by itself there (R58). */
  | { readonly kind: 'live'; readonly maxSeconds: number }
  /** Shown and refusing: a usage window is full, or Buddy is unavailable to the trainer (R3). */
  | { readonly kind: 'off'; readonly reason: 'limit' | 'unavailable' };

/**
 * `blocked` is the composer's own word for a full window: the status's, or a refusal held before
 * the status caught up with it.
 */
export function dictationOffer(status: StatusDto | undefined, blocked: boolean): AiDictationOffer {
  const maxSeconds = status?.dictation?.maxSeconds;
  if (status === undefined || maxSeconds === undefined || !Number.isFinite(maxSeconds) || maxSeconds <= 0) return { kind: 'none' };
  if (!status.available) return { kind: 'off', reason: 'unavailable' };
  if (blocked || status.blocked) return { kind: 'off', reason: 'limit' };
  return { kind: 'live', maxSeconds };
}
